module.exports = __webpack_public_path__ + "img/atalho-3.d8724ffb.png";